// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css — variables de diseño y base. El color de marca es el Pantone P 130-13 C
   (RGB 32 178 161 = #20B2A1). Ese turquesa NO da contraste suficiente con texto blanco
   (2,6:1), así que se usa tal cual para acentos, logo, bordes y selecciones, y su variante
   oscura (--brand-700, 5,1:1 con blanco) donde va texto blanco (botones, barra superior). */
:root {
  --brand: #20b2a1;
  --brand-50: #effaf8;
  --brand-100: #d5f3ef;
  --brand-200: #a9e6de;
  --brand-300: #6fd4c8;
  --brand-600: #159a8b;
  --brand-700: #0e7c6f;
  --brand-800: #0a6157;
  --brand-900: #064740;

  --ink: #10211f;
  --ink-2: #3b4f4c;
  --muted: #5b7370;
  --bg: #f1f6f5;
  --surface: #ffffff;
  --line: #d6e4e1;
  --line-2: #e7efed;
  --row-alt: #eaf4f2;      /* filas pares */
  --row-hover: #cdeee8;    /* fila bajo el ratón */
  --row-line: #c9dcd8;     /* separación entre filas */

  --ok: #15803d;
  --ok-bg: #dcf5e6;
  --ok-ink: #14632f;
  --warn: #b45309;
  --warn-bg: #fff1c9;
  --warn-ink: #7a4a05;
  --danger: #c62828;
  --danger-bg: #fde8e8;
  --danger-ink: #a61b1b;
  --wa: #16803c;

  --radius: 14px;
  --radius-sm: 10px;
  --shadow-1: 0 1px 2px rgba(6, 71, 64, .06), 0 1px 3px rgba(6, 71, 64, .06);
  --shadow-2: 0 4px 14px rgba(6, 71, 64, .10);
  --shadow-3: 0 18px 48px rgba(6, 35, 32, .28);
  --ring: 0 0 0 3px rgba(32, 178, 161, .30);
  --font: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
}

* { box-sizing: border-box; }

html { -webkit-text-size-adjust: 100%; }

body {
  margin: 0;
  font-family: var(--font);
  font-size: 15px;
  line-height: 1.45;
  background: var(--bg);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
}

::selection { background: var(--brand-200); color: var(--brand-900); }

h1, h2, h3, h4 { color: var(--ink); line-height: 1.2; letter-spacing: -.01em; }
a { color: var(--brand-700); }
code { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }

:focus-visible { outline: 2px solid var(--brand); outline-offset: 2px; }

@media (prefers-reduced-motion: reduce) {
  * { animation: none !important; transition: none !important; }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;4FAG4F;AAC5F;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB,OAAO,gBAAgB;EACzC,oBAAoB,KAAK,uBAAuB;EAChD,mBAAmB,MAAM,2BAA2B;;EAEpD,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;;EAEb,cAAc;EACd,iBAAiB;EACjB,0EAA0E;EAC1E,2CAA2C;EAC3C,4CAA4C;EAC5C,yCAAyC;EACzC,sGAAsG;AACxG;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B,OAAO,8BAA8B,EAAE;;AAEvC;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,cAAc,4BAA4B,EAAE,uBAAuB,EAAE;;AAErE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC9E,IAAI,uBAAuB,EAAE;AAC7B,OAAO,6EAA6E,EAAE;;AAEtF,iBAAiB,+BAA+B,EAAE,mBAAmB,EAAE;;AAEvE;EACE,IAAI,0BAA0B,EAAE,2BAA2B,EAAE;AAC/D","sourcesContent":["/* index.css — variables de diseño y base. El color de marca es el Pantone P 130-13 C\n   (RGB 32 178 161 = #20B2A1). Ese turquesa NO da contraste suficiente con texto blanco\n   (2,6:1), así que se usa tal cual para acentos, logo, bordes y selecciones, y su variante\n   oscura (--brand-700, 5,1:1 con blanco) donde va texto blanco (botones, barra superior). */\n:root {\n  --brand: #20b2a1;\n  --brand-50: #effaf8;\n  --brand-100: #d5f3ef;\n  --brand-200: #a9e6de;\n  --brand-300: #6fd4c8;\n  --brand-600: #159a8b;\n  --brand-700: #0e7c6f;\n  --brand-800: #0a6157;\n  --brand-900: #064740;\n\n  --ink: #10211f;\n  --ink-2: #3b4f4c;\n  --muted: #5b7370;\n  --bg: #f1f6f5;\n  --surface: #ffffff;\n  --line: #d6e4e1;\n  --line-2: #e7efed;\n  --row-alt: #eaf4f2;      /* filas pares */\n  --row-hover: #cdeee8;    /* fila bajo el ratón */\n  --row-line: #c9dcd8;     /* separación entre filas */\n\n  --ok: #15803d;\n  --ok-bg: #dcf5e6;\n  --ok-ink: #14632f;\n  --warn: #b45309;\n  --warn-bg: #fff1c9;\n  --warn-ink: #7a4a05;\n  --danger: #c62828;\n  --danger-bg: #fde8e8;\n  --danger-ink: #a61b1b;\n  --wa: #16803c;\n\n  --radius: 14px;\n  --radius-sm: 10px;\n  --shadow-1: 0 1px 2px rgba(6, 71, 64, .06), 0 1px 3px rgba(6, 71, 64, .06);\n  --shadow-2: 0 4px 14px rgba(6, 71, 64, .10);\n  --shadow-3: 0 18px 48px rgba(6, 35, 32, .28);\n  --ring: 0 0 0 3px rgba(32, 178, 161, .30);\n  --font: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n}\n\n* { box-sizing: border-box; }\n\nhtml { -webkit-text-size-adjust: 100%; }\n\nbody {\n  margin: 0;\n  font-family: var(--font);\n  font-size: 15px;\n  line-height: 1.45;\n  background: var(--bg);\n  color: var(--ink);\n  -webkit-font-smoothing: antialiased;\n}\n\n::selection { background: var(--brand-200); color: var(--brand-900); }\n\nh1, h2, h3, h4 { color: var(--ink); line-height: 1.2; letter-spacing: -.01em; }\na { color: var(--brand-700); }\ncode { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }\n\n:focus-visible { outline: 2px solid var(--brand); outline-offset: 2px; }\n\n@media (prefers-reduced-motion: reduce) {\n  * { animation: none !important; transition: none !important; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
